import { useTranslation } from 'react-i18next'

import { Divider } from '../../../Divider'
import { ProfileDateWithUserWidgetItem } from '../../ProfileDateWithUserWidgetItem'
import { ProfileFinishedWidgetRating } from '../ProfileFinishedWidgetRating'

import * as styles from './ProfileFinishedWidgetContent.module.css'

function ProfileFinishedWidgetContent({
  className = styles.ProfileFinishedWidgetContent,
  finishedAt,
  finishedBy,
  isRatingHidden,
  permissions,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      {isRatingHidden ? null : (
        <>
          <ProfileFinishedWidgetRating
            {...restProps}
            permissions={permissions}
          />
          <Divider className={styles.divider} />
        </>
      )}
      <ProfileDateWithUserWidgetItem
        canViewUser={permissions?.can_view_closed_by}
        className={styles.item}
        date={finishedAt}
        dateLabel={t('Widget.FinishedOnTitleKey')}
        user={finishedBy}
        userLabel={t('Widget.FinishedByTitleKey')}
      />
    </div>
  )
}

export default ProfileFinishedWidgetContent
